/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Fade from "@material-ui/core/Fade";
import { Formik } from "formik";
import Form from "../../components/Form";
import Dialog from "@material-ui/core/Dialog";
import { updateUserValidation } from "../../validation";
import { ToastContainer, toast } from "react-toastify";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import Loader from "../../components/Loader";
import { Auth, API } from "aws-amplify";
import moment from "moment";

const viewEditButton = { title: "Update", type: "submit" };

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});
function EditUser({
  handleClose,
  open,
  user,
  updateUserFunc,
  isFetchedUser,
  FetchedUserError,
  FetchedUserSuccess,
  FetchedUser,
  isFetchedParks,
  fetchedParksSuccess,
  fetchedParks,
  fetchedParksError,
}) {
  const [loading, setLoading] = useState(false);
  const [errorMess, setErrorMess] = useState("");
  const [oldGroup, setOldGroup] = useState(null);
  const [positionOptions] = useState([
    { value: "", label: "Select position" },
    { value: "owner", label: "Owner" },
    { value: "operation manager", label: "Operation Manager" },
    { value: "technician", label: "Technician" },
    { value: "operator", label: "Operator" },
  ]);
  const [languageOptions] = useState([
    { value: "", label: "Select language" },
    { value: "deutsch", label: "Deutsch" },
    { value: "english", label: "English" },
    { value: "francais", label: "Francais" },
    { value: "thai", label: "Thai" },
  ]);
  const [viewEditUserForm, setViewEditUserForm] = useState([
    {
      input: "text",
      type: "text",
      placeholder: "First Name",
      name: "firstName",
    },
    { input: "text", type: "text", placeholder: "Last Name", name: "lastName" },
    {
      input: "text",
      type: "date",
      placeholder: "Date of birth",
      name: "dateOfBirth",
      max: new Date(),
    },
    {
      input: "text",
      type: "email",
      placeholder: "Email",
      name: "email",
      disabled: true,
    },
    {
      input: "dropdown",
      placeholder: "Select position",
      options: positionOptions,
      name: "position",
      id: "position",
    },
    {
      input: "dropdown",
      placeholder: "Select language",
      options: languageOptions,
      name: "language",
      id: "language",
    },
  ]);
  const [loadForm, setLoadForm] = useState(true);
  const [dDValues, setDDValues] = useState({
    position: "",
    rights: "",
    park: "",
    language: "",
  });
  const [parkOptions, setParkOptions] = useState([]);

  useEffect(() => {
    let rightsOpt = [
      { value: "", label: "Select rights" },
      { value: "Admin", label: "Admin" },
      { value: "Technician", label: "Technician" },
      { value: "ReadOnly", label: "Read Only" },
    ];
    let formData = [...viewEditUserForm];
    let parkOpt = [{ value: "", label: "Select Park" }];
    let position = 0,
      rights = 0,
      language = 0,
      park = 0;
    positionOptions.forEach((option, index) =>
      option.value === user?.position ? (position = index) : ""
    );
    languageOptions.forEach((option, index) =>
      option.value === user?.language ? (language = index) : ""
    );
    if (FetchedUserSuccess && isFetchedUser) {
      let right = FetchedUser.rights.toLowerCase();
      let rightsField = viewEditUserForm.some(
        (field) => field.input === "dropdown" && field.id === "rights"
      );

      if (right === "superadmin") {
        rightsOpt.push({ value: "SuperAdmin", label: "Super Admin" });
        let parkField = viewEditUserForm.some((field) => field.id === "park");

        rightsOpt.forEach((option, index) =>
          option.value === user?.rights ? (rights = index) : ""
        );
        if (!rightsField)
          formData.push({
            input: "dropdown",
            type: "dropdown",
            placeholder: "Select right",
            options: rightsOpt,
            name: "rights",
            id: "rights",
          });

        if (!parkField)
          formData.push({
            input: "dropdown",
            type: "dropdown",
            placeholder: "Select park",
            options: parkOpt,
            name: "park",
            id: "park",
            hide:
              rightsOpt[rights].value.toLowerCase() === "superadmin"
                ? true
                : false,
          });
      } else if (!rightsField)
        formData.push({
          input: "dropdown",
          type: "dropdown",
          placeholder: "Select right",
          options: rightsOpt,
          name: "rights",
          id: "rights",
        });

      if (fetchedParksSuccess && isFetchedParks) {
        if (fetchedParks.length) {
          fetchedParks.map((park) =>
            parkOpt.push({
              value: JSON.stringify(park.id),
              label: park.name,
            })
          );

          if (right === "superadmin") {
            formData.forEach((field) =>
              field.id === "park" ? (field.options = parkOpt) : ""
            );
          }
        }
      } else if (fetchedParksError) {
        toast.error(`Error in getting of parks ${fetchedParksError}`);
      }

      rightsOpt.forEach((option, index) =>
        option.value === user?.rights ? (rights = index) : ""
      );
      parkOpt.forEach((option, index) =>
        option.value === user.park_id ? (park = index) : ""
      );
      setParkOptions(parkOpt);

      setDDValues({
        rights: rightsOpt[rights],
        position: positionOptions[position],
        language: languageOptions[language],
        park: parkOpt[park],
      });
      setOldGroup(rightsOpt[rights].value);
      setViewEditUserForm(formData);
      setLoading(false);
      setErrorMess("");
      setLoadForm(false);
    } else if (FetchedUserError) {
      setLoadForm(false);
      toast.error(`Error in getting user info ${FetchedUserError}`);
    }
  }, [user && isFetchedParks]);

  const handleSubmit = async ({
    firstName,
    lastName,
    dateOfBirth,
    email,
    position,
    language,
    rights,
    park,
  }) => {
    const data = {
      email,
      date_of_birth: moment(dateOfBirth).format("YYYY-MM-DD"),
      first_name: firstName,
      last_name: lastName,
      position: position.value,
      rights: rights.value,
      language: language.value,
      user_id: user.user_id,
      oldgroupname: oldGroup,
      newgroupname: rights.value,
      park_id: park.value,
    };

    setLoading(true);
    API.put("AdminQueries", "/api/v1/updateuser", {
      body: data,
      headers: {
        Authorization: (await Auth.currentSession())
          .getAccessToken()
          .getJwtToken(),
      },
    })
      .then((res) => {
        setLoading(false);
        updateUserFunc(data);
        handleClose();
        toast.success(res.message);
      })
      .catch((err) => {
        let updateUserError = err?.response?.data?.message
          ? err?.response?.data?.message
          : err.message;
        setErrorMess(updateUserError);
        setLoading(false);
      });
  };
  const values = {
    firstName: user?.first_name,
    lastName: user?.last_name,
    dateOfBirth: moment(user?.date_of_birth.split("T")[0]).format("MM/DD/YYYY"),
    email: user?.email,
    position: dDValues.position,
    language: dDValues.language,
    rights: dDValues.rights,
    park: dDValues.park,
  };
  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="simple-dialog-title"
        open={open}
        maxWidth="md"
        fullWidth
        className="dialogbox"
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose} />
        {loadForm ? (
          <Loader />
        ) : (
          <Fade in={open}>
            <Formik
              initialValues={values}
              validationSchema={updateUserValidation}
              onSubmit={handleSubmit}
            >
              {({
                handleSubmit,
                handleChange,
                setFieldTouched,
                setFieldValue,
                getFieldMeta,
                values,
                touched,
                errors,
              }) => {
                const onInputChange = (name, e, type) => {
                  if (type === "dropdown") {
                    setFieldValue(name, e, true);
                    if (
                      e.value.toString().toLowerCase() === "superadmin" &&
                      name === "rights"
                    ) {
                      if (
                        !getFieldMeta("park")?.value ||
                        !getFieldMeta("park")?.value.value
                      )
                        setFieldValue("park", parkOptions[1], true);
                      setViewEditUserForm((previousData) => {
                        let preData = [...previousData];
                        preData.filter((field) =>
                          field.id === "park" ? (field.hide = true) : ""
                        );
                        return preData;
                      });
                    } else if (
                      e.value.toString().toLowerCase() !== "superadmin" &&
                      name === "rights"
                    ) {
                      setViewEditUserForm((previousData) => {
                        let preData = [...previousData];
                        preData.filter((field) =>
                          field.id === "park" ? (field.hide = false) : ""
                        );
                        return preData;
                      });
                    }
                  } else if (name === "dateOfBirth") {
                    setFieldValue(
                      "dateOfBirth",
                      e,
                      // moment(e).format("YYYY-MM-DD").concat("T00:00Z"),
                      true
                    );
                  } else {
                    e.persist();
                    handleChange(e);
                  }
                  setFieldTouched(name, true, false);
                };
                return (
                  <Form
                    button={viewEditButton}
                    fields={viewEditUserForm}
                    id="View-Edit-User"
                    handleFormData={onInputChange}
                    data={values}
                    submitForm={handleSubmit}
                    touched={touched}
                    errors={errors}
                    loading={loading}
                    errorMessage={errorMess}
                  />
                );
              }}
            </Formik>
          </Fade>
        )}
      </Dialog>

      <ToastContainer position={toast.POSITION.TOP_RIGHT} autoClose={2000} />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    isFetchedUser: state?.users?.getUser?.isFetched,
    FetchedUserSuccess: state?.users?.getUser?.success,
    FetchedUserError: state?.users?.getUser?.error,
    FetchedUser: state?.users?.getUser?.user,
    isFetchedParks: state?.parks?.isFetched,
    fetchedParksSuccess: state?.parks?.success,
    fetchedParksError: state?.parks?.error,
    fetchedParks: state?.parks?.parks,
  };
}

export default connect(mapStateToProps, null)(EditUser);
